import { CustomerEndpoint } from '../common/endpoints';
import { LoyaltyPoint, ServerResponse } from '../common/types';
import { getRequest } from './requests';

export const getLoyaltyPointsByCustomerId = async (id: number) => {
    const result: ServerResponse<LoyaltyPoint[]> = await getRequest(`${CustomerEndpoint}/${id}/loyaltypoints`)
    if (result.data) {
        return result.data
    }
    return []
}